import DefaultLayout from '../../components/layouts/default-layout/DefaultLayout';
import { Route, useSearchParams } from 'react-router-dom';
import { DefaultLayoutHeaderType } from '../../components/layouts/default-layout/DefaultLayout.models';
import TicketRoute from '../../routes/ticket/ticket-route/TicketRoute';
import TicketEditionRoute from '../../routes/ticket/ticket-edition-route/TicketEditionRoute';
import PanelUpgradeRoute from '../../routes/panel-upgrade/PanelUpgradeRoute';
export default function ManagementRoute() {

    const [searchParams] = useSearchParams();
    return <>
        <Route element={<DefaultLayout showFooter={true} showDefaultHeader={DefaultLayoutHeaderType.showDefaultHeader} />}>
            <Route path="/PanelUpgrade" element={<PanelUpgradeRoute />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/About"} title={"لیست تیکت"} />}>
            <Route path="/TicketList" element={<TicketRoute />} />
        </Route>

        <Route element={<DefaultLayout backUri={"/About"} title={"ثبت تیکت"} />}>
            <Route path="/TicketEdition" element={<TicketEditionRoute inComing={searchParams.get('inComing')} />} />
        </Route>
    </>
}